import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('openai'),
  titleToNamespace: true,
  avatarPath: avatars.openAi,
  logoPath: logos.openAi
});
